import { MainTheme } from '@/components/Main/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const Main = GenericSlot({ as: 'main', theme: MainTheme });
